import {RouteEntity} from "@ots-frontend/ots-data";
import {BaseEntityMultiSelect, BaseEntityMultiSelectProps} from "../base-entity-multi-select";

export type BaseRouteMultiSelectProps = BaseEntityMultiSelectProps<RouteEntity>;

export const BaseRouteMultiSelect = (props: BaseRouteMultiSelectProps) => {
    return <BaseEntityMultiSelect {...props} />;
};
